import BulkCheckout from '@spa/components/pages/order/order/checkout/BulkCheckout.vue'
import StepByStepCheckout from '@spa/components/pages/order/order/checkout/StepByStepCheckout.vue'
import { CheckoutStore } from '@spa/components/pages/order/order/models/checkout-store'
import { Payment } from '@spa/store/modules/orderConfirm/types'
import Vue, { VueConstructor } from 'vue'

export function selectCheckoutView(
  checkoutStore: CheckoutStore,
  payment: Payment | null
): VueConstructor {
  // paymentが初期化されていなかったらローディング
  if (!payment || !payment.apiPayment) {
    return loadingCheckoutView
  }

  // 決済が複数に分割されない場合は支払い方法に関わらず一括決済UI
  if (!checkoutStore.hasMultipleCheckouts) {
    return BulkCheckout
  }

  // 決済が複数に分割されるが、複数の決済を1回で実行できる支払い方法の場合は一括決済UI
  if (payment.apiPayment.availableForMultipleOrders) {
    return BulkCheckout
  }

  return StepByStepCheckout
}

const loadingCheckoutView = Vue.extend({
  name: 'LoadingCheckoutView',
  template: '<div class="loading-checkout"></div>',
})
